/**
 * Campo que so faz sentido enquanto outro estiver marcado. A view declara
 * data-habilitado-por="<seletor do checkbox que manda>" e este helper cuida do
 * resto: enquanto o mandante estiver desmarcado, o dependente fica desabilitado
 * e desmarcado.
 *
 * O servidor ja ignora o dependente quando o mandante nao vem marcado. Isto
 * existe para a tela nao oferecer uma caixa que nao produz efeito nenhum -
 * marcar "exclusiva" numa regiao que ele nem atende.
 *
 * Desabilitar o checkbox nao tira o valor do POST: as tag helpers geram um
 * input hidden com "false" logo depois, e ele continua sendo enviado.
 */
export function iniciarCamposDependentes(escopo: ParentNode = document): void {
    escopo.querySelectorAll<HTMLInputElement>('[data-habilitado-por]').forEach(dependente => {
        const seletor = dependente.dataset.habilitadoPor;

        if (!seletor) {
            return;
        }

        const mandante = document.querySelector<HTMLInputElement>(seletor);

        if (!mandante) {
            return;
        }

        const aplicar = (): void => {
            dependente.disabled = !mandante.checked;

            if (dependente.disabled) {
                dependente.checked = false;
            }
        };

        mandante.addEventListener('change', aplicar);
        aplicar();
    });
}
